

















































import { Component, Prop, Emit, mixins } from 'nuxt-property-decorator'
import DotFlashing from '../shared/DotFlashing.vue'
import { LotAvailable } from '~/models'
import globalStyling from '~/mixins/globalStyling'

@Component({
  components: {
    DotFlashing,
  },
  mixins: [globalStyling],
})
export default class AvailableLotCardList extends mixins(globalStyling) {
  @Prop({ default: [] }) availableLots: Array<LotAvailable>
  @Prop({ default: undefined }) selectedLot: number

  selectedAvailableLot: number = null
  mouseDown: boolean = true
  // variables for controlling the sliding cards
  startX: number = 0
  scrollLeft: number = 0

  mounted() {
    if (this.selectedLot) {
      this.selectedAvailableLot = this.selectedLot
      this.orderSelectedLot(this.selectedAvailableLot)
    }
  }

  orderSelectedLot(lotNumber: number): void {
    const index = this.availableLots.findIndex((lot) => lot.id === lotNumber)
    if (index !== -1) {
      const selectedLot = this.availableLots[index]
      this.availableLots.splice(index, 1)
      this.availableLots.unshift(selectedLot)
      const slider = document.querySelector('.available-lots') as HTMLElement
      slider.scrollLeft = 0
    }
  }

  @Emit('lotHover')
  onLotListHover(lot: LotAvailable) {
    lot = {
      ...lot,
      centerpoint: [lot.longitude, lot.latitude],
    }
    return lot
  }

  @Emit('lotSelection')
  onLotSelection(lotNumber: number) {
    this.selectedAvailableLot =
      this.selectedAvailableLot !== lotNumber ? lotNumber : null

    if (this.selectedAvailableLot) {
      this.orderSelectedLot(this.selectedAvailableLot)
      return this.availableLots.find(
        (elem) => elem.id === this.selectedAvailableLot
      )
    }

    return null
  }

  handleMouseDown(e: any): void {
    const slider = document.querySelector('.available-lots') as HTMLElement
    this.mouseDown = true
    this.startX = e.pageX - slider.offsetLeft
    this.scrollLeft = slider.scrollLeft
  }

  handleMouseMove(e: any): void {
    if (!this.mouseDown) return
    const slider = document.querySelector('.available-lots') as HTMLElement
    const actualMousePosition = e.pageX - slider.offsetLeft
    const walk = actualMousePosition - this.startX
    slider.scrollLeft = this.scrollLeft - walk
  }

  @Emit('saveFav')
  saveFav(value: number): number {
    return value
  }

  getColor(isSaved: any) {
    const variable = isSaved ? '--cm-sp-fav-fill' : '--cm-sp-fav-outline'
    const color = this.getStyleVariableValue(variable)?.replace(/['"]+/g, '')
    if (color) return { color }
    return {}
  }
}
